<template>
  <ValidationProvider
    tag="div"
    v-bind="{ rules, vid }"
    :name="name"
    v-slot="{ errors }"
  >
    <div
      class="text-field text-field_floating-2 "
      :class="{ failed: errors[0] }"
    >
      <input
        @focus="onFocus"
        @blur="focused = false"
        class="text-field__input"
        :class="{ 'text-field__input-invalid': errors[0] }"
        :style="[errors[0] && innerValue ? { 'padding-right': '52px' } : '']"
        v-bind="{ type }"
        :placeholder="label"
        v-mask="mask"
        id="email"
        name="email"
        v-model="innerValue"
      />
      <div
        v-if="!pass"
        class="right__inputs"
        :style="errors[0] && innerValue ? { width: '40px' } : ''"
      >
        <span
          v-if="errors[0]"
          class="invalid"
          :style="errors[0] && innerValue ? { 'margin-right': '8px' } : ''"
        >
          <span class="message">{{ errors[0] }}</span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_348_2352)">
              <path
                d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
                fill="#D92A18"
              />
              <path
                d="M8 4.66663V8.66663"
                stroke="white"
                stroke-width="1.7"
                stroke-linecap="square"
                stroke-linejoin="round"
              />
              <path
                d="M8 11.3334V11.34"
                stroke="white"
                stroke-width="1.7"
                stroke-linecap="square"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_348_2352">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <span
          class="clear"
          style="margin-top: 2px;"
          v-if="innerValue"
          @click="innerValue = null"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 10.587L16.95 5.63702L18.364 7.05102L13.414 12.001L18.364 16.951L16.949 18.365L11.999 13.415L7.05 18.365L5.636 16.95L10.586 12L5.636 7.05002L7.05 5.63802L12 10.587Z"
              fill="black"
            />
          </svg>
        </span>
      </div>
      <div
        v-if="pass"
        class="right__inputs"
        :style="errors[0] && pass ? { width: '40px' } : ''"
      >
        <span
          v-if="errors[0]"
          class="invalid"
          :style="errors[0] && pass ? { 'margin-right': '8px' } : ''"
        >
          <span class="message">{{ errors[0] }}</span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_348_2352)">
              <path
                d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0Z"
                fill="#D92A18"
              />
              <path
                d="M8 4.66663V8.66663"
                stroke="white"
                stroke-width="1.7"
                stroke-linecap="square"
                stroke-linejoin="round"
              />
              <path
                d="M8 11.3334V11.34"
                stroke="white"
                stroke-width="1.7"
                stroke-linecap="square"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_348_2352">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="update-text" :class="{ 'update-text-active': focused }">
          <slot name="update-pass" />
        </span>
        <template>
          <span
            class="clear"
            v-if="type === 'text'"
            @click="$emit('updatePass', false)"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 3C17.392 3 21.878 6.88 22.819 12C21.879 17.12 17.392 21 12 21C6.608 21 2.122 17.12 1.182 12C2.122 6.88 6.608 3 12 3ZM12 19C14.0396 18.9998 16.0188 18.3071 17.6135 17.0355C19.2081 15.7638 20.3239 13.9884 20.778 12C20.3226 10.0128 19.2065 8.23896 17.612 6.96854C16.0175 5.69813 14.0392 5.00635 12.0005 5.00635C9.96181 5.00635 7.98346 5.69813 6.389 6.96854C4.79454 8.23896 3.67836 10.0128 3.223 12C3.6771 13.9883 4.79267 15.7635 6.38714 17.0352C7.98161 18.3068 9.96053 18.9996 12 19ZM12 16.5C10.8065 16.5 9.66193 16.0259 8.81802 15.182C7.97411 14.3381 7.5 13.1935 7.5 12C7.5 10.8065 7.97411 9.66193 8.81802 8.81802C9.66193 7.97411 10.8065 7.5 12 7.5C13.1935 7.5 14.3381 7.97411 15.182 8.81802C16.0259 9.66193 16.5 10.8065 16.5 12C16.5 13.1935 16.0259 14.3381 15.182 15.182C14.3381 16.0259 13.1935 16.5 12 16.5ZM12 14.5C12.663 14.5 13.2989 14.2366 13.7678 13.7678C14.2366 13.2989 14.5 12.663 14.5 12C14.5 11.337 14.2366 10.7011 13.7678 10.2322C13.2989 9.76339 12.663 9.5 12 9.5C11.337 9.5 10.7011 9.76339 10.2322 10.2322C9.76339 10.7011 9.5 11.337 9.5 12C9.5 12.663 9.76339 13.2989 10.2322 13.7678C10.7011 14.2366 11.337 14.5 12 14.5Z"
                fill="black"
              />
            </svg>
          </span>
          <span
            class="clear"
            v-if="type === 'password'"
            @click="$emit('updatePass', true)"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.343 18.782L7.411 18.264L8.198 15.325C7.01998 14.8905 5.92514 14.2573 4.961 13.453L2.808 15.607L1.394 14.193L3.547 12.039C2.33107 10.5827 1.51409 8.83575 1.176 6.96899L3.144 6.60999C3.52145 8.68379 4.61467 10.5594 6.23313 11.9099C7.85158 13.2603 9.89262 14 12.0005 14C14.1084 14 16.1494 13.2603 17.7679 11.9099C19.3863 10.5594 20.4795 8.68379 20.857 6.60999L22.825 6.96799C22.4867 8.83518 21.6694 10.5825 20.453 12.039L22.607 14.193L21.193 15.607L19.039 13.453C18.0748 14.2573 16.98 14.8905 15.802 15.325L16.59 18.265L14.658 18.782L13.87 15.842C12.6324 16.0541 11.3676 16.0541 10.13 15.842L9.343 18.782Z"
                fill="black"
              />
            </svg>
          </span>
        </template>
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import { VueMaskDirective } from "v-mask";
export default {
  name: "app-input",
  props: {
    bg: {
      type: String,
      default: "#191b1f"
    },
    pass: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    vid: {
      type: String,
      default: undefined
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    label: {
      type: String,
      required: true
    },
    mask: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      innerValue: "",
      focused: false,
      eye: false
    };
  },
  watch: {
    innerValue(value) {
      this.$emit("input", value);
    },
    value: {
      handler: function(val) {
        if (val !== this.innerValue) {
          if (this.type == "number") {
            this.innerValue = String(val).replace(".", ",");
          }
          this.innerValue = val;
        }
      }
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    onFocus() {
      this.$emit("focus");
      this.focused = true;
    },
    openPass() {}
  },
  directives: {
    mask: VueMaskDirective
  }
};
</script>
<style scoped>
/* text field */
.text-field {
  margin-bottom: 24px;
}

.text-field__input {
  display: block;
  width: 100%;

  height: 24px;
  padding: 0.375rem 0;
  padding: 0;
  font-family: inherit;
  font-weight: 400;
  font-size: 13px;
  border: none !important;
  line-height: 24px;
  color: var(--main-black);
  font-size: 18px;
  font-weight: 700;
  background-clip: padding-box;
  background-color: transparent;
  /* transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.text-field__input[type="search"]::-webkit-search-decoration,
.text-field__input[type="search"]::-webkit-search-cancel-button,
.text-field__input[type="search"]::-webkit-search-results-button,
.text-field__input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.text-field__input::placeholder {
  opacity: 0.4;
}

.text-field__input:focus {
  background-color: transparent;
  outline: 0;
}

.text-field__input:disabled,
.text-field__input[readonly] {
  background-color: transparent;
  opacity: 1;
}

/* with floating label */
.text-field_floating-2 {
  position: relative;
}

.text-field_floating-2 .text-field__label {
  position: absolute;
  top: 50%;
  left: 0.3125rem;
  display: flex;
  transform: translateY(-50%);
  pointer-events: none;
  border: none;

  color: #757575;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  transition: top 0.1s ease-in-out, scale 0.1s ease-in-out;
}

.text-field_floating-2 .text-field__input::-moz-placeholder {
  color: transparent;
}

.text-field_floating-2 .text-field__input::placeholder {
  color: transparent;
}

.text-field_floating-2 .text-field__input:focus ~ .text-field__label,
.text-field_floating-2
  .text-field__input:not(:placeholder-shown)
  ~ .text-field__label {
  top: 0;
  left: 9px;
  transform: translateY(-50%);
  font-size: 11px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
.text-field {
  position: relative;
}
.right__inputs {
  display: flex;
  position: absolute;
  align-items: center;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
  height: 16px;
  width: 16px;
  cursor: pointer;
  transition: 0.2s;
}
.invalid,
.clear {
  width: 16px;
}
.invalid {
  position: relative;
}
.update-text {
  color: #fff;
  position: absolute;
  font-size: 13px;
  line-height: 16px;
  white-space: nowrap;
  left: -115px;
}

.message {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  font-size: 11px;
  white-space: nowrap;
  line-height: 18px;
  top: -30%;
  left: 50%;
  transform: translate(-50%, -100%);
  clip-path: polygon(
    0% 0%,
    100% 0%,
    100% 85%,
    55% 85%,
    50% 100%,
    45% 85%,
    0 85%
  );
  padding: 6px 10px 14px 10px;
}

.clear {
  /* transform: translate(0, -50%); */
}
/* .text-field__input-invalid {
  border-color: #d92a18;
} */
@media screen and (max-width: 615px) {
  .message {
    left: 17px;
    transform: translate(-100%, -100%);
    clip-path: polygon(
      0% 0%,
      100% 0%,
      100% 90%,
      100% 90%,
      94% 100%,
      86% 91%,
      0 90%
    );
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/AppInput.vue